/**
 * Multipart upload. XHR is used because fetch has no upload progress events.
 * The access token is sent the same way as core/api.js; the body stays FormData
 * so the browser can set the multipart boundary.
 */

function token() {
  try {
    return localStorage.getItem('accessToken') || '';
  } catch {
    return '';
  }
}

/** @param {File[]} files @param {(pct: number) => void} [onProgress] */
export function uploadFiles(files, onProgress) {
  const body = new FormData();
  for (const file of files) body.append('files', file);
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/v1/chat/upload');
    const access = token();
    if (access) xhr.setRequestHeader('Authorization', `Bearer ${access}`);
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && onProgress) {
        onProgress(Math.round((event.loaded / event.total) * 100));
      }
    };
    xhr.onload = () => {
      let data = null;
      try { data = JSON.parse(xhr.responseText || ''); } catch { data = null; }
      if (xhr.status >= 200 && xhr.status < 300 && data && Array.isArray(data.files)) {
        resolve(data.files);
        return;
      }
      reject(new Error((data && data.error) || 'Upload failed'));
    };
    xhr.onerror = () => reject(new Error('Upload failed'));
    xhr.send(body);
  });
}
